import { render, staticRenderFns } from "./kulutusluotto.vue?vue&type=template&id=01497e21&"
import script from "./kulutusluotto.vue?vue&type=script&lang=js&"
export * from "./kulutusluotto.vue?vue&type=script&lang=js&"
import style0 from "./kulutusluotto.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports